import { useContext } from 'react';
import { LocalizationContext } from '../i18n/LocalizationProvider';

export default function useTranslate(
  text: string
): string {
  const i18n = useContext<LocalizationContext>(LocalizationContext);

  return i18n.t(text)
}